export default __webpack_public_path__ + "static/Screen Shot 2021-12-02 at 19.30.10-78375dafc819fed8fd71b448df93525a.png";